import React from 'react';

import AndroidSection from './LandingPage/platformSection/AndroidSection';
import IosSection from './LandingPage/platformSection/IosSection';
import {Reference} from "../../res/Reference";
import MainSection from "./LandingPage/MainSection";
import FooterSection from "./LandingPage/FooterSection";
import {FaqSection} from "./LandingPage/faqSection/FaqSection";

interface States {
}

interface Props {
}

class LandingPage extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {

        return (
            <div
                className="landing-page">

                <MainSection/>

                <div
                    id={Reference.downloadAppSection}>

                    <AndroidSection/>
                    <IosSection/>

                </div>

                <FaqSection/>

                <FooterSection/>
            </div>
        )
    }
}

export default LandingPage;
